import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const BlockReview = ({ store }) => {
  const currency = store.getState().generalsettings.generalSettings.currency;
  const [shipordeliver, setShipOrDeliver] = useState(store.getState().selectedorderdata?.shipordeliverdata || '');

  const [totalformat, setTotalFormat] = useState(store.getState().shoppingcart.metacartdata?.[0]?.totalpriceformat || '');
  const [shippingprice, setShippingPrice] = useState(store.getState().selectedorderdata.shippingdata?.pricewithtax || '');
  const [totalprice, setTotalPrice] = useState(store.getState().shoppingcart.metacartdata?.[0]?.totalprice || '');
 



  useEffect(() => {

    const updateStore = () => {

    
      const metacartdata = store.getState().shoppingcart.metacartdata;
      if (metacartdata && metacartdata.length > 0) {
        setTotalFormat(metacartdata[0].totalpriceformat);
        setTotalPrice(metacartdata[0].totalprice);
        
        
      }
      const selectedorderdata = store.getState().selectedorderdata;
      if(selectedorderdata && selectedorderdata.length > 0){
        setShipOrDeliver(selectedorderdata.shipordeliverdata);
        setShippingPrice(selectedorderdata.shippingdata?.pricewithtax)
      }
    };
        // Redux Store abonnieren
  const unsubscribe = store.subscribe(updateStore);


  return () => {

    unsubscribe();
  };
}, []);
  

  const renderSubtotals = () => {
    return (
      <>
  
        <div className="row g-3 pt-4 pb-4 mb-0">
          <div className="col-4 ps-3 ips-checkout-review-subtotaltext">Zwischensumme:</div>
          <div className="col-5">
         
          </div>
          <div className="col-3 ">
            <div className="text-center ips-checkout-review-subtotalprice" dangerouslySetInnerHTML={{ __html: totalformat !== 0 ? totalformat : "" }}></div>
          </div>
        </div>
        <div className="row g-3 pt-4 pb-4 mb-0">
          <div className="col-4  ps-3">Versand:</div>
          <div className="col-5">
        
          </div>
          <div className="col-3">
          <div className="text-center" dangerouslySetInnerHTML={{ __html: shippingprice !== 0 &&  shippingprice !== "" && shipordeliver !== "pickup" ? (parseFloat(shippingprice)).toFixed(2) +" "+ currency : "Kostenlos!" }}></div>
          </div>
        </div>
      </>
    );
  };

  const renderTotalAmount = () => {
    return (
      <>
        <hr className="my-0 mx-2" />
        <div className="row g-3 pt-4 pb-4 mb-0">
          <div className="col-4  ps-3 ips-checkout-review-totalpricetext">Gesamtsumme:</div>
          <div className="col-5"></div>
          <div className="col-3">
          <div className="text-center ips-checkout-review-totalprice" dangerouslySetInnerHTML={{ __html: shippingprice !== 0 &&  shippingprice !== "" && shipordeliver !== "pickup" ? (parseFloat(totalprice) + parseFloat(shippingprice)).toFixed(2) +" "+ currency : (parseFloat(totalprice)).toFixed(2) +" "+ currency }}></div>
          </div>
        </div>
      </>
    );
  };

 
  

  return (
    <div id="ips-checkout-orderreview-details" className="ips-module">
      <div className="row g-3">
        <div className="col-12">
          <div className="border border-1 pt-4 pb-0 my-4 rounded">
    
            {/*<hr className="my-0 mx-1" />*/}
            {renderSubtotals()}
            {renderTotalAmount()}
      
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlockReview;